import React from "react";
import { connect } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { withRouter } from '../shared/hoc/withRouter';
// import { withLastLocation } from "react-router-dom-last-location";
import UserPage from "../pages/user/UserPage";
import ReportsRouter from "../pages/reports/Router";
import ContractsRouter from "../pages/home/Routers/ContractsRouter";
import Actions from "../pages/home/Actions";
import ContractRouter from "../pages/home/Routers/ContractRouter";
import AdminRouter from "../pages/admin/Router";
import DownloadsRouter from "../pages/downloads/Router";
import Protector from "../router/Protector/Protector";
import { IdleTimer } from '../widgets/IdleTimerComponent';
import { custom as CustomDialog } from 'devextreme/ui/dialog';
import { injectIntl } from "react-intl";
import * as authDuck from "../store/ducks/auth.duck";
import moment from 'moment';
import NavigateToDefault from "./NavigateToDefault";
import AIChatBot from "../pages/home/AIChatBot";
import Search from "../pages/home/Search";
// import { getLastLocation } from "./RouterHelpers";

const globalSearchEnabled = process.env.REACT_APP_GLOBAL_SEARCH_ENABLED === "true";

const idleDetectionTimeout = Number(process.env.REACT_APP_IDLE_EXPIRE_MS);
const idleDetectionWarningCountdown = 60;
class AppRoutesWT extends React.Component {
  constructor(props) {
    super(props)
    this.idleTimer = null
    this.refPowerBIEmbedded = React.createRef();

  }

  //if not intercepted by any response to prompt
  //IdleTimer will trigger this function indicating IDLE period has ended
  onIdle = () => {
    // User did not respond to prompt in time
    // IDLE CASE - close the dialog onPrompt function will take care of the rest
    if (this.idleDialog) {
      this.idleDialog.hide();
    }
  }
  //Function is called by IdleTimer when IDLE period is about the reach
  //we should display the warning prompt
  onIdlePrompt = async () => {
    window.beeb = new Audio("data:audio/wav;base64,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");
    try { window.beeb.play(); } catch { }

    setTimeout(() => { try { window.beeb.play(); } catch { } }, 2000)
    // setTimeout(()=>{ window.beeb.play();},4000)
    // await this.sleep(2000);
    // window.beeb.play();
    let secondCounter = idleDetectionWarningCountdown;
    let formattedSeconds = moment().startOf('day').seconds(secondCounter).format('mm:ss');

    this.idleDialog = CustomDialog({
      title: this.props.intl.formatMessage({ id: "SYSTEM.SESSION_IDLE_SIGNOUT_TITLE" }),
      messageHtml: `<div style="max-width:50vw;"><p>${this.props.intl.formatMessage({ id: "SYSTEM.SESSION_IDLE_SIGNOUT_MESSAGE" })} ${this.props.intl.formatMessage({ id: "SYSTEM.SESSION_IDLE_SIGNOUT_TIME_REMAINING" })} : <span id="sessionCounter" style="font-weight:bold;" >${formattedSeconds}</span></p></div>`,
      buttons: [
        {
          text: this.props.intl.formatMessage({ id: "SYSTEM.SESSION_IDLE_SIGNOUT_LEAVE_BUTTON" }),
          onClick: (e) => { return "LOGOUT" }
        },
        {
          text: this.props.intl.formatMessage({ id: "SYSTEM.SESSION_IDLE_SIGNOUT_STAY_BUTTON" }),
          type: "default",
          stylingMode: "outlined",
          onClick: (e) => { return "STAY" }
        }
      ]
    });

    const secondCounterInterval = setInterval(() => {
      const element = document.getElementById('sessionCounter');
      secondCounter = secondCounter - 1;
      formattedSeconds = moment().startOf('day').seconds(secondCounter).format('mm:ss');
      if (element) {
        element.innerText = formattedSeconds;
      }
    }, (1 * 1000));
    const result = await this.idleDialog.show();
    clearInterval(secondCounterInterval);


    if (result === "STAY") {
      this.idleTimer.reset();
    }
    else {
      //clicked logout or not responses in time
      console.log("Logout process initiated due to no user activity!")
      this.props.navigate('/logout');
      // this.props.startLogout();
    }
  }
  render() {
    const { userProfile, Layout, location, shouldRedirectToUserPageForConsent } = this.props;

    if (shouldRedirectToUserPageForConsent && location.pathname !== `/user/${userProfile.accountid}/overview`) {
      return (
        <Navigate replace to={`/user/${userProfile.accountid}/overview`} state={{ redirectedForConsent: true }} />
        // <Layout>
        //   <Routes caseSensitive>
        //     <Route path="/user/:userid/overview" element={<Protector><UserPage /></Protector>} sensitive />
        //     <Route path="*" element={<Navigate replace to={`/user/${userProfile.accountid}/overview`} state={{ redirectedForConsent: true }} />} />
        //   </Routes>
        // </Layout>
      )
    }
    return (
      <>
        {
          idleDetectionTimeout && (
            <IdleTimer
              ref={ref => { this.idleTimer = ref }}
              onIdle={this.onIdle}
              timeout={idleDetectionTimeout}
              onPrompt={this.onIdlePrompt}
              promptBeforeIdle={idleDetectionWarningCountdown * 1000}
              startOnMount={true}
            />
          )
        }

        <Layout refPowerBIEmbedded={this.refPowerBIEmbedded}>
    <div id="fastdraft-content">
        <Routes caseSensitive>
            <Route path="/user/:userid/overview" element={<Protector><UserPage /></Protector>} sensitive />
            <Route path="/contract/:contractid/*" element={<ContractRouter />} sensitive />
            <Route path="/contracts/*" element={<ContractsRouter />} sensitive />
            <Route path="/actions/*" element={<Actions />} sensitive />

            {globalSearchEnabled && (
                <Route path="/search/*" element={<Search />} sensitive />
            )}

            <Route path="/reports/*" element={<ReportsRouter refPowerBIEmbedded={this.refPowerBIEmbedded} />} sensitive />
            <Route path="/downloads/*" element={<DownloadsRouter />} sensitive />
            <Route path="/admin/*" element={<AdminRouter />} sensitive />
            <Route path="*" element={<NavigateToDefault />} />
        </Routes>
    </div>

              <AIChatBot />
          </Layout>
      </>

    );
  }
}

const mapStateToProps = (store) => ({
  userProfile: store.auth.userProfile,
  shouldRedirectToUserPageForConsent: store.auth.userProfile && store.auth.userProfile.shouldRedirectToUserPageForConsent
});
const mapDispatchToProps = {
  startLogout: authDuck.actions.startLogout
};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(AppRoutesWT)));
